
<div v-if="numSundays || numSaturdays || numWeekdays" class="pb-5 mt-5 text-left pl-2">
	<div class="black-text font-weight-black black--text mt-4 mb-2" style="font-size: 1rem">{{ getLabel('bookingFlowBookingSummaryTitle', 'Booking Summary') }}</div>
	<div style="font-size: 13px; color: #3e3e3e">
		<template v-if="showExpandedShiftSummary">
			<div>
				<strong>{{ getLabel('bookingFlowMinRatePerHour', 'Minimum rate per hour') }}:</strong>
				<span class="ml-2">R{{ minimumRatePerHour.toLocaleString() }}</span>
			</div>
			<div>
				<strong>{{ getLabel('bookingFlowTotalHours', 'Total hours for this booking') }}:</strong>
				<span class="ml-2">{{ totalHoursDisplay }}</span>
			</div>
			<div>
				<strong>{{ getLabel('bookingFlowApproxEarnings', 'Approx total earnings for this booking') }}:</strong>
				<span class="ml-2">R{{ total }}</span>
			</div>
			<hr class="mt-3 mb-3" style="background: #f0f0f0; width: 90%; border: none; height: 2px" />
		</template>
		<template v-else>
			<div v-if="numWeekdays">
				<strong> Weekday Rate x {{ numWeekdays }}:</strong>
				<span class="ml-2">R{{ ratesForWeekdays.toLocaleString() }}</span>
			</div>
			<div v-if="numSaturdays">
				<strong>Saturday Rate x {{ numSaturdays }}:</strong>
				<span class="ml-2">R{{ ratesForSaturdays.toLocaleString() }}</span>
			</div>
			<div v-if="numSundays">
				<strong>Sunday/Public Holiday Rate x {{ numSundays }}:</strong>
				<span class="ml-2">R{{ ratesForSundays.toLocaleString() }}</span>
			</div>
			<div v-if="lunchDetails.text">
				<strong>Lunch:</strong>
				<span class="ml-2"
					>{{ lunchDetails.text }} <span v-if="lunchDetails.showCost">{{ `(less R${totalLunch})` }}</span></span
				>
			</div>
			<hr class="mt-3 mb-3" style="background: #f0f0f0; width: 90%; border: none; height: 2px" />
			<div>
				<strong>{{ getLabel('bookingFlowBookingSummaryTotalTitle', 'Total Estimated Locum Fee') }}:</strong>
				<span class="ml-2">R{{ total }}</span>
			</div>
		</template>
	</div>
	<div v-if="!showExpandedShiftSummary">
		<small>*Excludes <a href="https://locumbase.com/pricing" target="_blank">Facilitation Fee</a> </small>
	</div>
</div>
